import { pdf } from "@react-pdf/renderer";

import type { ApiClient } from "api/ApiClient";
import type { UserCourseExercise } from "api/schemas/UserCourse";

import { ProtocolAsPDF } from "./ProtocolAsPDF";
import type { PDFPatientInfo, PDFTranslations } from "./types";

type GenerateProtocolPDFParams = {
  client: ApiClient;
  patientId: number;
  translations: PDFTranslations;
  patientInfo: PDFPatientInfo;
  formattedDate: string;
  scheduleVersion: number | undefined | null;
};

export const generateProtocolPDF = async ({
  client,
  patientId,
  translations,
  patientInfo,
  formattedDate,
  scheduleVersion,
}: GenerateProtocolPDFParams): Promise<void> => {
  let exercises: UserCourseExercise[] = [];

  if (scheduleVersion === 2) {
    const treatmentSchedule = await client.getPatientTreatmentSchedule(patientId);
    exercises = await Promise.all(
      treatmentSchedule.exercises.map(async (ex: { exercise_id: number; recommended_level: number }) => {
        const exercise = await client.getExercise(ex.exercise_id);
        return { ...exercise, current_level: ex.recommended_level };
      })
    );
  } else {
    const userCourse = await client.getUserCourse(patientId);
    exercises = userCourse.exercises;
  }

  const blob = await pdf(
    <ProtocolAsPDF
      exercises={exercises}
      translations={translations}
      patientInfo={patientInfo}
      formattedDate={formattedDate}
    />
  ).toBlob();

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${patientInfo.name} - protocol.pdf`;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 30000);
};
